module.exports = __webpack_public_path__ + "954d66fe12bd1b1225e8f1c1a1eeae01.svg";